import { render } from "./ProductDiagnosis.vue?vue&type=template&id=f80ddf76&scoped=true"
import script from "./ProductDiagnosis.vue?vue&type=script&lang=js"
export * from "./ProductDiagnosis.vue?vue&type=script&lang=js"

import "./ProductDiagnosis.vue?vue&type=style&index=0&id=f80ddf76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80ddf76"],['__file',"src/views/ProductDiagnosis/ProductDiagnosis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f80ddf76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f80ddf76', __exports__)) {
    api.reload('f80ddf76', __exports__)
  }
  
  module.hot.accept("./ProductDiagnosis.vue?vue&type=template&id=f80ddf76&scoped=true", () => {
    api.rerender('f80ddf76', render)
  })

}


export default __exports__